"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.WorkflowStatusValues = exports.ExternalTransferWorkflowStatus = exports.MoveTransactionWorkflowStatus = exports.FundMergerWorkflowStatus = exports.CashInterestActivityWorkflowStatus = exports.AdvancedCorrectionWorkflowStatus = exports.CashTransferWorkflowStatus = exports.IndividualSubAccountOrderWorkflowStatus = exports.ReversalWorkflowStatus = exports.FeeRequestWorkflowStatus = exports.DisbursementRequestWorkflowStatus = exports.DisbursementWorkflowStatus = exports.CorrectionByAmountWorkflowStatus = exports.DistributionRequestWorkflowStatus = exports.BookPushedDepositStatus = exports.PlanLiquidationWorkflowStatus = exports.DepositRequestWorkflowStatus = exports.InvestmentUpdateWorkflowStatus = exports.AllocateDepositWorkflowStatus = exports.InvestContributionWorkflowStatus = exports.FlattenRequestWorkflowStatus = exports.TradeRequestWorkflowStatus = exports.NewPlanWorkflowStatus = exports.CommonWorkflowStatus = void 0;
var CommonWorkflowStatus;
(function (CommonWorkflowStatus) {
    CommonWorkflowStatus["Complete"] = "COMPLETE";
})(CommonWorkflowStatus = exports.CommonWorkflowStatus || (exports.CommonWorkflowStatus = {}));
var NewPlanWorkflowStatus;
(function (NewPlanWorkflowStatus) {
    NewPlanWorkflowStatus["ValidationError"] = "VALIDATION_ERROR";
    NewPlanWorkflowStatus["Queued"] = "QUEUED";
    NewPlanWorkflowStatus["CreateInternalAccounts"] = "CREATE_INTERNAL_ACCOUNTS";
    NewPlanWorkflowStatus["PendingCustodianAccount"] = "PENDING_CUSTODIAN_ACCOUNT";
    NewPlanWorkflowStatus["ConfirmCustodianAccount"] = "CONFIRM_CUSTODIAN_ACCOUNT";
    NewPlanWorkflowStatus["Complete"] = "COMPLETE";
    NewPlanWorkflowStatus["Rejected"] = "REJECTED";
})(NewPlanWorkflowStatus = exports.NewPlanWorkflowStatus || (exports.NewPlanWorkflowStatus = {}));
var TradeRequestWorkflowStatus;
(function (TradeRequestWorkflowStatus) {
    TradeRequestWorkflowStatus["ValidationError"] = "VALIDATION_ERROR";
    TradeRequestWorkflowStatus["PendingProcessing"] = "PENDING_PROCESSING";
    TradeRequestWorkflowStatus["ProcessingError"] = "PROCESSING_ERROR";
    TradeRequestWorkflowStatus["PendingInvestment"] = "PENDING_INVESTMENT";
    TradeRequestWorkflowStatus["CompleteNoTrades"] = "COMPLETE_NO_TRADES";
    TradeRequestWorkflowStatus["Complete"] = "COMPLETE";
    TradeRequestWorkflowStatus["ProcessingAborted"] = "PROCESSING_ABORTED";
})(TradeRequestWorkflowStatus = exports.TradeRequestWorkflowStatus || (exports.TradeRequestWorkflowStatus = {}));
var FlattenRequestWorkflowStatus;
(function (FlattenRequestWorkflowStatus) {
    FlattenRequestWorkflowStatus["ValidationError"] = "VALIDATION_ERROR";
    FlattenRequestWorkflowStatus["PendingProcessing"] = "PENDING_PROCESSING";
    FlattenRequestWorkflowStatus["ProcessingError"] = "PROCESSING_ERROR";
    FlattenRequestWorkflowStatus["PendingInvestment"] = "PENDING_INVESTMENT";
    FlattenRequestWorkflowStatus["CompleteNoTrades"] = "COMPLETE_NO_TRADES";
    FlattenRequestWorkflowStatus["Complete"] = "COMPLETE";
    FlattenRequestWorkflowStatus["ProcessingAborted"] = "PROCESSING_ABORTED";
})(FlattenRequestWorkflowStatus = exports.FlattenRequestWorkflowStatus || (exports.FlattenRequestWorkflowStatus = {}));
var InvestContributionWorkflowStatus;
(function (InvestContributionWorkflowStatus) {
    InvestContributionWorkflowStatus["ValidationError"] = "VALIDATION_ERROR";
    InvestContributionWorkflowStatus["PendingProcessing"] = "PENDING_PROCESSING";
    InvestContributionWorkflowStatus["ProcessingError"] = "PROCESSING_ERROR";
    InvestContributionWorkflowStatus["PendingInvestment"] = "PENDING_INVESTMENT";
    InvestContributionWorkflowStatus["Complete"] = "COMPLETE";
    InvestContributionWorkflowStatus["ProcessingAborted"] = "PROCESSING_ABORTED";
})(InvestContributionWorkflowStatus = exports.InvestContributionWorkflowStatus || (exports.InvestContributionWorkflowStatus = {}));
var AllocateDepositWorkflowStatus;
(function (AllocateDepositWorkflowStatus) {
    AllocateDepositWorkflowStatus["ValidationError"] = "VALIDATION_ERROR";
    AllocateDepositWorkflowStatus["PendingProcessing"] = "PENDING_PROCESSING";
    AllocateDepositWorkflowStatus["ProcessingError"] = "PROCESSING_ERROR";
    AllocateDepositWorkflowStatus["Complete"] = "COMPLETE";
    AllocateDepositWorkflowStatus["ProcessingAborted"] = "PROCESSING_ABORTED";
})(AllocateDepositWorkflowStatus = exports.AllocateDepositWorkflowStatus || (exports.AllocateDepositWorkflowStatus = {}));
var InvestmentUpdateWorkflowStatus;
(function (InvestmentUpdateWorkflowStatus) {
    InvestmentUpdateWorkflowStatus["ValidatingRequest"] = "VALIDATING_REQUEST";
    InvestmentUpdateWorkflowStatus["ValidationError"] = "VALIDATION_ERROR";
    InvestmentUpdateWorkflowStatus["Queued"] = "QUEUED";
    InvestmentUpdateWorkflowStatus["ProcessingCustodianInvestmentUpdate"] = "PROCESSING_CUSTODIAN_INVESTMENT_UPDATE";
    InvestmentUpdateWorkflowStatus["PendingCustodianInvestmentUpdate"] = "PENDING_CUSTODIAN_INVESTMENT_UPDATE";
    InvestmentUpdateWorkflowStatus["InvestmentUpdateError"] = "INVESTMENT_UPDATE_ERROR";
    InvestmentUpdateWorkflowStatus["Complete"] = "COMPLETE";
})(InvestmentUpdateWorkflowStatus = exports.InvestmentUpdateWorkflowStatus || (exports.InvestmentUpdateWorkflowStatus = {}));
var DepositRequestWorkflowStatus;
(function (DepositRequestWorkflowStatus) {
    DepositRequestWorkflowStatus["Queued"] = "QUEUED";
    DepositRequestWorkflowStatus["ValidationError"] = "VALIDATION_ERROR";
    DepositRequestWorkflowStatus["PendingACHProcessing"] = "PENDING_ACH_PROCESSING";
    DepositRequestWorkflowStatus["ACHConfirmed"] = "ACH_CONFIRMED";
    DepositRequestWorkflowStatus["FundingConfirmed"] = "FUNDING_CONFIRMED";
    DepositRequestWorkflowStatus["ACHRejected"] = "ACH_REJECTED";
    DepositRequestWorkflowStatus["Complete"] = "COMPLETE";
    DepositRequestWorkflowStatus["Failed"] = "FAILED";
    DepositRequestWorkflowStatus["ProcessingAborted"] = "PROCESSING_ABORTED";
    DepositRequestWorkflowStatus["ProcessingACH"] = "PROCESSING_ACH";
})(DepositRequestWorkflowStatus = exports.DepositRequestWorkflowStatus || (exports.DepositRequestWorkflowStatus = {}));
var PlanLiquidationWorkflowStatus;
(function (PlanLiquidationWorkflowStatus) {
    PlanLiquidationWorkflowStatus["Queued"] = "QUEUED";
    PlanLiquidationWorkflowStatus["ValidationError"] = "VALIDATION_ERROR";
    PlanLiquidationWorkflowStatus["Liquidating"] = "LIQUIDATING";
    PlanLiquidationWorkflowStatus["Failed"] = "FAILED";
    PlanLiquidationWorkflowStatus["CashTransferInitiated"] = "CASH_TRANSFER_INITIATED";
    PlanLiquidationWorkflowStatus["CashTransferFailed"] = "CASH_TRANSFER_FAILED";
    PlanLiquidationWorkflowStatus["DisbursementsInitiated"] = "DISBURSEMENTS_INITIATED";
    PlanLiquidationWorkflowStatus["Disbursing"] = "DISBURSING";
    PlanLiquidationWorkflowStatus["Disbursed"] = "DISBURSED";
    PlanLiquidationWorkflowStatus["DisbursementCleared"] = "DISBURSEMENT_CLEARED";
    PlanLiquidationWorkflowStatus["DisbursementRejected"] = "DISBURSEMENT_REJECTED";
    PlanLiquidationWorkflowStatus["Complete"] = "COMPLETE";
})(PlanLiquidationWorkflowStatus = exports.PlanLiquidationWorkflowStatus || (exports.PlanLiquidationWorkflowStatus = {}));
var BookPushedDepositStatus;
(function (BookPushedDepositStatus) {
    BookPushedDepositStatus["ValidatingRequest"] = "VALIDATING_REQUEST";
    BookPushedDepositStatus["ValidationError"] = "VALIDATION_ERROR";
    BookPushedDepositStatus["PostingDeposits"] = "POSTING_DEPOSITS";
    BookPushedDepositStatus["Complete"] = "COMPLETE";
})(BookPushedDepositStatus = exports.BookPushedDepositStatus || (exports.BookPushedDepositStatus = {}));
var DistributionRequestWorkflowStatus;
(function (DistributionRequestWorkflowStatus) {
    DistributionRequestWorkflowStatus["ValidationError"] = "VALIDATION_ERROR";
    DistributionRequestWorkflowStatus["PendingProcessing"] = "PENDING_PROCESSING";
    DistributionRequestWorkflowStatus["PendingLiquidation"] = "PENDING_LIQUIDATION";
    DistributionRequestWorkflowStatus["ProcessingError"] = "PROCESSING_ERROR";
    DistributionRequestWorkflowStatus["ProcessingAborted"] = "PROCESSING_ABORTED";
    DistributionRequestWorkflowStatus["DisbursementsInitiated"] = "DISBURSEMENTS_INITIATED";
    DistributionRequestWorkflowStatus["DisbursementError"] = "DISBURSEMENT_ERROR";
    DistributionRequestWorkflowStatus["Complete"] = "COMPLETE";
})(DistributionRequestWorkflowStatus = exports.DistributionRequestWorkflowStatus || (exports.DistributionRequestWorkflowStatus = {}));
var CorrectionByAmountWorkflowStatus;
(function (CorrectionByAmountWorkflowStatus) {
    CorrectionByAmountWorkflowStatus["Queued"] = "QUEUED";
    CorrectionByAmountWorkflowStatus["ValidationError"] = "VALIDATION_ERROR";
    CorrectionByAmountWorkflowStatus["Liquidating"] = "LIQUIDATING";
    CorrectionByAmountWorkflowStatus["Complete"] = "COMPLETE";
})(CorrectionByAmountWorkflowStatus = exports.CorrectionByAmountWorkflowStatus || (exports.CorrectionByAmountWorkflowStatus = {}));
var DisbursementWorkflowStatus;
(function (DisbursementWorkflowStatus) {
    DisbursementWorkflowStatus["Cleared"] = "CLEARED";
    DisbursementWorkflowStatus["Confirmed"] = "CONFIRMED";
    DisbursementWorkflowStatus["Rejected"] = "REJECTED";
    DisbursementWorkflowStatus["Outstanding"] = "OUTSTANDING";
    DisbursementWorkflowStatus["Cashed"] = "CASHED";
})(DisbursementWorkflowStatus = exports.DisbursementWorkflowStatus || (exports.DisbursementWorkflowStatus = {}));
var DisbursementRequestWorkflowStatus;
(function (DisbursementRequestWorkflowStatus) {
    DisbursementRequestWorkflowStatus["Queued"] = "QUEUED";
    DisbursementRequestWorkflowStatus["Disbursing"] = "DISBURSING";
    DisbursementRequestWorkflowStatus["Cleared"] = "CLEARED";
    DisbursementRequestWorkflowStatus["Confirmed"] = "CONFIRMED";
    DisbursementRequestWorkflowStatus["Failed"] = "FAILED";
    DisbursementRequestWorkflowStatus["DisbursementRejected"] = "REJECTED";
    DisbursementRequestWorkflowStatus["ProcessingAborted"] = "PROCESSING_ABORTED";
    DisbursementRequestWorkflowStatus["Outstanding"] = "OUTSTANDING";
    DisbursementRequestWorkflowStatus["Cancelled"] = "CANCELLED";
    DisbursementRequestWorkflowStatus["PendingApproval"] = "PENDING_APPROVAL";
})(DisbursementRequestWorkflowStatus = exports.DisbursementRequestWorkflowStatus || (exports.DisbursementRequestWorkflowStatus = {}));
var FeeRequestWorkflowStatus;
(function (FeeRequestWorkflowStatus) {
    FeeRequestWorkflowStatus["ValidationError"] = "VALIDATION_ERROR";
    FeeRequestWorkflowStatus["PendingAllocation"] = "PENDING_ALLOCATION";
    FeeRequestWorkflowStatus["PendingProcessing"] = "PENDING_PROCESSING";
    FeeRequestWorkflowStatus["PendingLiquidation"] = "PENDING_LIQUIDATION";
    FeeRequestWorkflowStatus["ProcessingError"] = "PROCESSING_ERROR";
    FeeRequestWorkflowStatus["ProcessingAborted"] = "PROCESSING_ABORTED";
    FeeRequestWorkflowStatus["FeeTransferInitiated"] = "FEE_TRANSFER_INITIATED";
    FeeRequestWorkflowStatus["FeeTransferError"] = "FEE_TRANSFER_ERROR";
    FeeRequestWorkflowStatus["Complete"] = "COMPLETE";
})(FeeRequestWorkflowStatus = exports.FeeRequestWorkflowStatus || (exports.FeeRequestWorkflowStatus = {}));
var ReversalWorkflowStatus;
(function (ReversalWorkflowStatus) {
    ReversalWorkflowStatus["ValidationError"] = "VALIDATION_ERROR";
    ReversalWorkflowStatus["PendingProcessing"] = "PENDING_PROCESSING";
    ReversalWorkflowStatus["ProcessingError"] = "PROCESSING_ERROR";
    ReversalWorkflowStatus["Complete"] = "COMPLETE";
    ReversalWorkflowStatus["ProcessingAborted"] = "PROCESSING_ABORTED";
})(ReversalWorkflowStatus = exports.ReversalWorkflowStatus || (exports.ReversalWorkflowStatus = {}));
var IndividualSubAccountOrderWorkflowStatus;
(function (IndividualSubAccountOrderWorkflowStatus) {
    IndividualSubAccountOrderWorkflowStatus["PendingProcessing"] = "PENDING_PROCESSING";
    IndividualSubAccountOrderWorkflowStatus["PendingInvestment"] = "PENDING_INVESTMENT";
    IndividualSubAccountOrderWorkflowStatus["ProcessingError"] = "PROCESSING_ERROR";
    IndividualSubAccountOrderWorkflowStatus["Complete"] = "COMPLETE";
    IndividualSubAccountOrderWorkflowStatus["ProcessingAborted"] = "PROCESSING_ABORTED";
})(IndividualSubAccountOrderWorkflowStatus = exports.IndividualSubAccountOrderWorkflowStatus || (exports.IndividualSubAccountOrderWorkflowStatus = {}));
var CashTransferWorkflowStatus;
(function (CashTransferWorkflowStatus) {
    CashTransferWorkflowStatus["ValidationError"] = "VALIDATION_ERROR";
    CashTransferWorkflowStatus["PendingProcessing"] = "PENDING_PROCESSING";
    CashTransferWorkflowStatus["ProcessingError"] = "PROCESSING_ERROR";
    CashTransferWorkflowStatus["Complete"] = "COMPLETE";
    CashTransferWorkflowStatus["ProcessingAborted"] = "PROCESSING_ABORTED";
})(CashTransferWorkflowStatus = exports.CashTransferWorkflowStatus || (exports.CashTransferWorkflowStatus = {}));
var AdvancedCorrectionWorkflowStatus;
(function (AdvancedCorrectionWorkflowStatus) {
    AdvancedCorrectionWorkflowStatus["ValidationError"] = "VALIDATION_ERROR";
    AdvancedCorrectionWorkflowStatus["Queued"] = "QUEUED";
    AdvancedCorrectionWorkflowStatus["Complete"] = "COMPLETE";
    AdvancedCorrectionWorkflowStatus["ProcessingError"] = "PROCESSING_ERROR";
    AdvancedCorrectionWorkflowStatus["ProcessingAborted"] = "PROCESSING_ABORTED";
})(AdvancedCorrectionWorkflowStatus = exports.AdvancedCorrectionWorkflowStatus || (exports.AdvancedCorrectionWorkflowStatus = {}));
var CashInterestActivityWorkflowStatus;
(function (CashInterestActivityWorkflowStatus) {
    CashInterestActivityWorkflowStatus["Queued"] = "QUEUED";
    CashInterestActivityWorkflowStatus["Complete"] = "COMPLETE";
    CashInterestActivityWorkflowStatus["ProcessingError"] = "PROCESSING_ERROR";
})(CashInterestActivityWorkflowStatus = exports.CashInterestActivityWorkflowStatus || (exports.CashInterestActivityWorkflowStatus = {}));
var FundMergerWorkflowStatus;
(function (FundMergerWorkflowStatus) {
    FundMergerWorkflowStatus["Queued"] = "QUEUED";
    FundMergerWorkflowStatus["ProcessingError"] = "PROCESSING_ERROR";
    FundMergerWorkflowStatus["Complete"] = "COMPLETE";
})(FundMergerWorkflowStatus = exports.FundMergerWorkflowStatus || (exports.FundMergerWorkflowStatus = {}));
var MoveTransactionWorkflowStatus;
(function (MoveTransactionWorkflowStatus) {
    MoveTransactionWorkflowStatus["Queued"] = "QUEUED";
    MoveTransactionWorkflowStatus["Complete"] = "COMPLETE";
    MoveTransactionWorkflowStatus["ProcessingError"] = "PROCESSING_ERROR";
    MoveTransactionWorkflowStatus["ValidationError"] = "VALIDATION_ERROR";
})(MoveTransactionWorkflowStatus = exports.MoveTransactionWorkflowStatus || (exports.MoveTransactionWorkflowStatus = {}));
var ExternalTransferWorkflowStatus;
(function (ExternalTransferWorkflowStatus) {
    ExternalTransferWorkflowStatus["Queued"] = "QUEUED";
    ExternalTransferWorkflowStatus["ValidationError"] = "VALIDATION_ERROR";
    ExternalTransferWorkflowStatus["ProcessingExternalTrades"] = "PROCESSING_EXTERNAL_TRADES";
    ExternalTransferWorkflowStatus["ProcessingExternalTradesComplete"] = "PROCESSING_EXTERNAL_TRADES_COMPLETE";
    ExternalTransferWorkflowStatus["ProcessingTrades"] = "PROCESSING_TRADES";
    ExternalTransferWorkflowStatus["ProcessingTradesComplete"] = "PROCESSING_TRADES_COMPLETE";
    ExternalTransferWorkflowStatus["Complete"] = "COMPLETE";
    ExternalTransferWorkflowStatus["Failed"] = "FAILED";
    ExternalTransferWorkflowStatus["Rejected"] = "REJECTED";
    ExternalTransferWorkflowStatus["Deferred"] = "DEFERRED";
})(ExternalTransferWorkflowStatus = exports.ExternalTransferWorkflowStatus || (exports.ExternalTransferWorkflowStatus = {}));
exports.WorkflowStatusValues = Object.values(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, CommonWorkflowStatus), NewPlanWorkflowStatus), TradeRequestWorkflowStatus), FlattenRequestWorkflowStatus), InvestContributionWorkflowStatus), InvestmentUpdateWorkflowStatus), DepositRequestWorkflowStatus), BookPushedDepositStatus), ReversalWorkflowStatus), IndividualSubAccountOrderWorkflowStatus), DistributionRequestWorkflowStatus), DisbursementWorkflowStatus), FeeRequestWorkflowStatus), PlanLiquidationWorkflowStatus), CashTransferWorkflowStatus), CorrectionByAmountWorkflowStatus), AdvancedCorrectionWorkflowStatus), DisbursementRequestWorkflowStatus), AllocateDepositWorkflowStatus), CashInterestActivityWorkflowStatus), FundMergerWorkflowStatus), MoveTransactionWorkflowStatus), ExternalTransferWorkflowStatus));
